/* unplugin-vue-components disabled */import { render } from "./pbl_s.vue?vue&type=template&id=4754ffef"
import script from "./pbl_s.vue?vue&type=script&lang=js"
export * from "./pbl_s.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__